import { useEffect } from 'react';
import { store } from '../..';
import { dealerActionCreators } from '../../ducks/dealer';

export const useDealers = (type: 'local' | 'global') => {
  useEffect(() => {
    store.dispatch(dealerActionCreators.fetchDealerList(type));
  }, []);
};
